module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Détails du magasin',
        backToList: 'Retour à la liste des magasins'
    };

    return resources[label];
};
